import { connect } from 'react-redux'
import OrdersEditView from './OrdersEditView.jsx'


class OrdersUncompleteView extends OrdersEditView {
  constructor(props, context) {
    const localProps = {
      ...props,
      initialState: {
        status: 'shipped'
      }
    }

    super(localProps, context)
  }
}

const mapStateToProps = (state) => {
  return {
    page: 'uncomplete',
    order: state.orders.current.order,
    currentUser: state.currentUser.user,
    skus: state.skus.all || [],
    serverErrors: state.errors.orders.create || {}
  }
}

const connectedOrdersUncompleteView = connect(mapStateToProps,)(OrdersUncompleteView)
export default connectedOrdersUncompleteView